export default __webpack_public_path__ + "static/media/serviciosAlarma2Mobile.c4f1ca34.png";